import { render } from "./Footer.vue?vue&type=template&id=feeb8b04&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=feeb8b04&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1684190759/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feeb8b04"]])

export default __exports__